<template>
	<section class="page">
		<div class="d-print-none">
			<h2>{{info.type.name}}</h2>
			<div
				class
				v-if="info.warehouse._id || info.supplier._id"
			>{{info.warehouse.name}} / {{info.supplier.name}}</div>
		</div>
		<el-tabs v-model="activeName">
			<el-tab-pane label="出入库信息" name="info">
				<div v-if="activeName=='info'" v-loading="loadings.main">
					<div class="operator">
						<div class="operator-col">
							<el-button size="mini" @click="doPrint()">打印</el-button>
						</div>
						<div class="operator-col">
							<el-tag size="medium" :type="info.status.index==30?'success':'danger'">{{info.status.name}}</el-tag>
						</div>
						<div class="operator-col" v-if="hasEdit(info)">
							<el-button size="mini" @click="goTxEdit(info._id)">编辑</el-button>
						</div>
						<template v-if="info.type.index==20">
							<!-- 出库操作 -->
							<div class="operator-col" v-if="info.status.index==10 ">
								<el-button size="mini" @click="goSendTx(info._id)">发货</el-button>
							</div>
							<div class="operator-col" v-if="info.status.index==10 ">
								<el-button size="mini" @click="goRejectTx(info._id)">打回</el-button>
							</div>
							<div class="operator-col" v-if="info.status.index==20 ">
								<el-button size="mini" @click="goRecvTx(info._id)">已收货</el-button>
							</div>
						</template>
						<template v-else-if="info.type.index==21">
							<!-- 入库操作 -->
							<div class="operator-col" v-if="info.status.index==11">
								<el-button size="mini" @click="doHasVerify(info._id)">审核</el-button>
							</div>
							<div class="operator-col" v-if="info.status.index==11">
								<el-button size="mini" @click="doDeleteTx(info._id)">删除</el-button>
							</div>
						</template>
						<template v-if="info.type.index==22">
							<!-- 退库操作 -->
							<div class="operator-col" v-if="info.status.index==20 ">
								<el-button size="mini" @click="goRecvTx(info._id)">收到退货</el-button>
							</div>
							<!-- <div class="operator-col" v-if="info.status.index==20 ">
								<el-button size="mini" @click="goRejectTx(info._id)">打回</el-button>
							</div>-->
						</template>
						<template v-if="info.type.index==23">
							<!-- 退货供应商操作 -->
							<div class="operator-col" v-if="info.status.index==11">
								<el-button size="mini" @click="doHasVerify(info._id)">审核</el-button>
							</div>
							<div class="operator-col" v-if="info.status.index==11">
								<el-button size="mini" @click="doDeleteTx(info._id)">删除</el-button>
							</div>
						</template>
						<template v-if="info.type.index==24">
							<!-- 预售入库操作 -->
							<div class="operator-col" v-if="info.status.index==11">
								<el-button size="mini" @click="doHasVerify(info._id)">审核</el-button>
							</div>
							<div class="operator-col">
								<el-button size="mini" @click="doDuplate(info._id)">转入库单</el-button>
							</div>
							<div class="operator-col" v-if="info.status.index==11">
								<el-button size="mini" @click="doDeleteTx(info._id)">删除</el-button>
							</div>
						</template>
						<template v-else-if="info.type.index==31">
							<!-- 入库操作 -->
							<div class="operator-col" v-if="info.status.index==11">
								<el-button size="mini" @click="doHasVerify(info._id)">审核</el-button>
							</div>
						</template>
						<template v-else-if="info.type.index==40">
							<!-- 入库操作 -->
							<div class="operator-col" v-if="info.status.index==11">
								<el-button size="mini" @click="doHasVerify(info._id)">审核</el-button>
							</div>
						</template>
					</div>
					<outbound :info="info" :record-id="recordId" ref="baseInfoTable" v-if="info.type.index==20"></outbound>
					<inbound
						:info="info"
						:record-id="recordId"
						ref="baseInfoTable"
						v-else-if="info.type.index==21 || info.type.index==23 || info.type.index==24"
					></inbound>
					<stocktaking
						:info="info"
						:record-id="recordId"
						ref="baseInfoTable"
						v-else-if="info.type.index==31"
					></stocktaking>
					<scheduling
						:info="info"
						:record-id="recordId"
						ref="baseInfoTable"
						v-else-if="info.type.index==40"
					></scheduling>
					<backbound
						:info="info"
						:record-id="recordId"
						ref="baseInfoTable"
						v-else-if="info.type.index==22"
					></backbound>
					<curd-table
						class="content-box"
						:auto-load="false"
						ref="listItemTable"
						data-model="Tx_item"
						:fields="itemsTableFieldsReal"
						:list-ops="[]"
						:has-delete="false"
						:has-page="false"
						:show-summary="true"
					></curd-table>
				</div>
			</el-tab-pane>
			<el-tab-pane label="编辑" name="edit" v-if="hasEdit(info)">
				<div class="content-box" v-if="activeName=='edit'" v-loading="loadings.main">
					<edit-in-bound v-if="info.type.index==21" ref="editor" :record-id="recordId" v-model="info"></edit-in-bound>
					<edit-in-bound
						type="pre"
						v-if="info.type.index==24"
						ref="editor"
						:record-id="recordId"
						v-model="info"
					></edit-in-bound>
					<edit-out-bound v-if="info.type.index==20" ref="editor" :record-id="recordId" v-model="info"></edit-out-bound>
					<edit-stocktaking v-if="info.type.index==31" ref="editor" :record-id="recordId" v-model="info"></edit-stocktaking>
					<edit-scheduling v-if="info.type.index==40" ref="editor" :record-id="recordId" v-model="info"></edit-scheduling>
				</div>
			</el-tab-pane>
		</el-tabs>
		<editor
			:show.sync="editorVisible"
			data-model-name="Transaction"
			:record-id="editorId"
			:fields="sendFields"
			handler-url="inventory/do_tx_op/send/"
			@change="onSendTx"
		></editor>
		<editor
			:show.sync="editorVisibleRecv"
			data-model-name="Transaction"
			:record-id="editorId"
			:fields="sendFieldsRecv"
			:checkEverEdited="false"
			handler-url="inventory/do_tx_op/recv/"
			@change="onSendTx"
		></editor>
	</section>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import CurdPage from "@/mixins/CurdPage.js";
import TabPage from "@/mixins/TabPage.js";
import TxOp from "@/mixinsApp/TxOp.js";
import Outbound from "@/views/Inventory/Infos/Outbound.vue";
import Inbound from "@/views/Inventory/Infos/Inbound.vue";
import Stocktaking from "@/views/Inventory/Infos/Stocktaking.vue";
import Scheduling from "@/views/Inventory/Infos/Scheduling.vue";
import Backbound from "@/views/Inventory/Infos/Backbound.vue";
import EditInBound from "@/views/Inventory/subs/EditInbound";
import EditOutBound from "@/views/Inventory/subs/EditOutBound";
import EditStocktaking from "@/views/Inventory/subs/EditStocktaking";
import EditScheduling from "@/views/Inventory/subs/EditScheduling";

export default {
	config: {
		names: {},
	},
	mixins: [CurdPage, TabPage, TxOp],
	components: {
		Outbound,
		Inbound,
		Backbound,
		Stocktaking,
		Scheduling,
		EditInBound,
		EditOutBound,
		EditStocktaking,
		EditScheduling,
	},
	data() {
		return {
			isInfoPage: true,
			loadings: {
				main: false,
			},
			recordId: "",
			activeName: "info",
			editorVisibleRecv: false,
			info: {
				_id: "",
				type: {
					index: 0,
					name: "",
				},
				status: {
					index: 0,
					name: "",
				},
				items: [],
				warehouse: {
					_id: "",
				},
				supplier: {
					_id: "",
				},
			},
			hasGetData: false,
			itemsTableFields: [
				{
					name: "brand_show_id",
				},
				{
					name: "brand",
				},
				{
					name: "product_color",
				},
				{
					name: "model",
				},
				{
					name: "warehouse",
				},
				{
					name: "price_per",
				},
				{
					name: "amount",
				},
				{
					name: "total_price",
				},
			],
		};
	},
	computed: {
		...mapState(["userPrivilegeMapping"]),
		itemsTableFieldsReal() {
			return this.itemsTableFields.filter(key => {
				if (
					(key.name == "cost_per" ||
						key.name == "price_per" ||
						key.name == "total_price") &&
					!this.userPrivilegeMapping[59]
				) {
					return false;
				}
				return true;
			});
		},
	},
	created() {},
	mounted() {
		// this.refreshRoute();
	},
	methods: {
		refreshRoute() {
			this.recordId = this.$route.params.id;
			if (this.$route.params.tab) {
				this.activeName = this.$route.params.tab;
			}
			this.refreshData();
		},
		setData(data) {
			this.info = Object.assign({}, data.info);
			if (data.tx_items) {
				this.info.items = data.tx_items;
			}

			this.$nextTick(() => {
				if (this.$refs["baseInfoTable"]) {
					this.$refs["baseInfoTable"].setData(data.info);
				}
				if (data.tx_items && this.$refs["listItemTable"]) {
					this.$refs["listItemTable"].setData(data.tx_items);
				}
			});
		},
		refreshData() {
			// debugger;
			this.loadings.main = true;
			this.$axios
				.post(`/inventory/tx_info/${this.recordId}`)
				.then(json => {
					this.loadings.main = false;
					this.setData(json.data);
					this.hasGetData = true;
				})
				.catch(json => {
					console.error(json);
					// debugger;
					this.$message.error(json.data.msg);
					this.loadings.main = false;
					this.$router.push({
						name: "Inventory-Log",
						params: {},
					});
				});
		},
		onSendTx() {
			this.refreshData();
		},
	},
	watch: {
		hasGetTableDataModel: {
			handler(val) {
				if (val) {
					// this._refreshRules();
				}
			},
			immediate: true,
		},
	},
};
</script>
<style lang="scss" scoped>
</style>
